export default {
  dynamics: '{{change}} față de {{time_unit}} anterior',
};
